import Button from '@mui/material/Button';
import { Divider } from "@mui/material";
import Modal from "react-modal";
import React from "react";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

Modal.setAppElement("#root");

const TokenExpiredModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customStyles}
      contentLabel="Token Expired Modal"
    >
      <h2>Token has expired</h2>
      <p>Please login to continue</p>
      <Button 
        variant="contained" 
        color="primary" 
        onClick={() => window.location.href = '/'}
        sx={{ mt: 2 }} // Added some margin top using MUI v5's sx prop
      >
        Login
      </Button>
    </Modal>
  );
};

export default TokenExpiredModal;